<template>
  <div v-if="!hasPermission('List Transaction Category')">Você não tem permissão para acessar esta página!</div>
  <div v-else>
    <Toolbar />
    <div class="container-xxl">
    <div class="card">
      <div class="card-header">
        <div class="card-title">
          <div class="d-flex align-items-center position-relative my-1">
            <span class="svg-icon svg-icon-1 position-absolute ms-6">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1"
                      transform="rotate(45 17.0365 15.1223)" fill="black"></rect>
                <path
                    d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z"
                    fill="black"></path>
              </svg>
            </span>
            <input type="text" data-kt-user-table-filter="search" v-model="search"
                   class="form-control form-control-solid w-250px ps-14"
                   placeholder="Pesquisar ...">
          </div>
        </div>
        <div class="card-toolbar">
          <div class="d-flex gap-2">
            <select v-model="filterType" class="form-select form-select-solid w-150px">
              <option value="">Todos os tipos</option>
              <option value="expense">Despesa</option>
              <option value="income">Receita</option>
            </select>
            <button v-if="hasPermission('Store Transaction Category')" class="btn btn-flex btn-primary m-1" data-bs-toggle="modal"
                    title="Nova categoria" data-bs-target="#modal_store_transaction_category"
                    @click="resetFormStore">
              <i class="bi bi-plus-lg"></i> Adicionar
            </button>
          </div>
        </div>
      </div>
      <div class="card-body py-4">
        <table class="table table-row-bordered gy-5">
          <thead>
          <tr class="fw-bold fs-6 text-muted">
            <th>Nome</th>
            <th>Tipo</th>
            <th>Descrição</th>
            <th>Ativo</th>
            <th>Ações</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="category in categoriesFiltered" :key="category.id">
            <td>{{ category.name }}</td>
            <td>
              <span :class="category.type === 'income' ? 'badge badge-success' : 'badge badge-danger'">
                {{ category.type === 'income' ? 'Receita' : 'Despesa' }}
              </span>
            </td>
            <td>{{ category.description || '-' }}</td>
            <td>
              <span :class="category.active ? 'badge badge-success' : 'badge badge-danger'">
                {{ category.active ? 'Sim' : 'Não' }}
              </span>
            </td>
            <td>
              <button v-if="hasPermission('Update Transaction Category')" type="button" class="btn btn-icon btn-bg-light btn-active-color-primary me-1"
                      :disabled="category.is_system"
                      :data-bs-toggle="category.is_system ? null : 'modal'"
                      :data-bs-target="category.is_system ? null : '#modal_edit_transaction_category'"
                      @click="onClickBtnEdit(category)"
                      :title="category.is_system ? 'Registros do sistema não podem ser editados' : 'Editar'">
                <i class="bi bi-pencil-square"></i>
              </button>
              <button v-if="hasPermission('Delete Transaction Category')" class="btn btn-icon btn-bg-light btn-active-color-primary me-1"
                      :disabled="category.is_system"
                      @click="deleteCategory(category.id)"
                      data-bs-toggle="tooltip"
                      :title="category.is_system ? 'Registros do sistema não podem ser excluídos' : 'Excluir'">
                <i class="bi bi-trash"></i>
              </button>
            </td>
          </tr>
          <tr v-if="categoriesFiltered.length === 0">
            <td colspan="5" class="text-center text-muted py-10">
              Nenhuma categoria cadastrada
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Modal Store -->
    <div class="modal fade" tabindex="-1" id="modal_store_transaction_category">
      <div class="modal-dialog modal-lg">
        <form method="post" @submit.prevent="submitFormStore">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Nova Categoria de Transação</h5>
              <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal"
                   aria-label="Fechar">
                <i class="bi bi-x-lg"></i>
              </div>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="mb-6">
                    <label for="name_store" class="required form-label">Nome</label>
                    <input type="text" class="form-control form-control-solid" id="name_store"
                           placeholder="Ex: Aluguel, Salários, Vendas"
                           v-model="formStore.name" required>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="mb-6">
                    <label for="type_store" class="required form-label">Tipo</label>
                    <select class="form-select form-select-solid" id="type_store"
                            v-model="formStore.type" required>
                      <option value="">Selecione o tipo</option>
                      <option value="expense">Despesa</option>
                      <option value="income">Receita</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="mb-6">
                    <label for="description_store" class="form-label">Descrição</label>
                    <textarea class="form-control form-control-solid" id="description_store"
                              rows="3" placeholder="Descrição opcional da categoria"
                              v-model="formStore.description"></textarea>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-check form-check-custom form-check-solid">
                    <input class="form-check-input" type="checkbox"
                           v-model="formStore.active" id="active_store" checked/>
                    <label class="form-check-label" for="active_store">
                      Ativo
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-light" data-bs-dismiss="modal">Fechar</button>
              <button type="submit" class="btn btn-primary">Cadastrar</button>
            </div>
          </div>
        </form>
      </div>
    </div>

    <!-- Modal Edit -->
    <div class="modal fade" tabindex="-1" id="modal_edit_transaction_category">
      <div class="modal-dialog modal-lg">
        <form method="post" @submit.prevent="submitFormEdit">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Editar Categoria de Transação</h5>
              <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal"
                   aria-label="Fechar">
                <i class="bi bi-x-lg"></i>
              </div>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="mb-6">
                    <label for="name_edit" class="required form-label">Nome</label>
                    <input type="text" class="form-control form-control-solid" id="name_edit"
                           placeholder="Ex: Aluguel, Salários, Vendas"
                           v-model="formEdit.name" required>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="mb-6">
                    <label for="type_edit" class="required form-label">Tipo</label>
                    <select class="form-select form-select-solid" id="type_edit"
                            v-model="formEdit.type" required>
                      <option value="">Selecione o tipo</option>
                      <option value="expense">Despesa</option>
                      <option value="income">Receita</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="mb-6">
                    <label for="description_edit" class="form-label">Descrição</label>
                    <textarea class="form-control form-control-solid" id="description_edit"
                              rows="3" placeholder="Descrição opcional da categoria"
                              v-model="formEdit.description"></textarea>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-check form-check-custom form-check-solid">
                    <input class="form-check-input" type="checkbox"
                           v-model="formEdit.active" id="active_edit"/>
                    <label class="form-check-label" for="active_edit">
                      Ativo
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-light" data-bs-dismiss="modal">Fechar</button>
              <button type="submit" class="btn btn-primary">Salvar</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import http from "@/helpers/http";
import Alert from "@/helpers/alert";
import Permission from "@/helpers/permission";
import Toolbar from "@/components/layouts/auth/Toolbar.vue";

export default {
  name: "TransactionCategory",
  components: {
    Toolbar,
  },
  data() {
    return {
      search: '',
      filterType: '',
      categories: [],
      formStore: {
        name: '',
        type: '',
        description: '',
        active: true,
      },
      formEdit: {
        id: null,
        name: '',
        type: '',
        description: '',
        active: true,
      },
    }
  },
  computed: {
    place() {
      return this.$store.state.auth.place;
    },
    categoriesFiltered() {
      let filtered = this.categories.filter(category => {
        const matchesSearch = category.name.toLowerCase().includes(this.search.toLowerCase()) ||
                            (category.description && category.description.toLowerCase().includes(this.search.toLowerCase()));
        const matchesType = !this.filterType || category.type === this.filterType;
        return matchesSearch && matchesType;
      });
      return filtered;
    },
  },
  mounted() {
    this.loadCategories();
  },
  methods: {
    hasPermission(permission) {
      return Permission.has(permission);
    },
    loadCategories() {
      http.get(`/places/${this.place.id_place}/finances/transaction-categories`).then((response) => {
        this.categories = response.data;
      }).catch(() => {
        this.categories = [];
      });
    },
    resetFormStore() {
      this.formStore = {
        name: '',
        type: '',
        description: '',
        active: true,
      };
    },
    submitFormStore() {
      http.post(`/places/${this.place.id_place}/finances/transaction-categories`, this.formStore).then(() => {
        this.loadCategories();
        Alert.toastSuccess("Categoria cadastrada com sucesso.");
        this.resetFormStore();
        bootstrap.Modal.getInstance(document.getElementById('modal_store_transaction_category')).hide();
      }).catch(e => {
        Alert.toastError(e.response?.data?.message || "Erro ao cadastrar categoria.");
      });
    },
    submitFormEdit() {
      http.put(`/places/${this.place.id_place}/finances/transaction-categories/${this.formEdit.id}`, this.formEdit).then(() => {
        this.loadCategories();
        Alert.toastSuccess("Categoria atualizada com sucesso.");
        bootstrap.Modal.getInstance(document.getElementById('modal_edit_transaction_category')).hide();
      }).catch(e => {
        Alert.toastError(e.response?.data?.message || "Erro ao atualizar categoria.");
      });
    },
    onClickBtnEdit(category) {
      if (category.is_system) {
        Alert.toastError("Registros do sistema não podem ser editados.");
        return;
      }
      this.formEdit = {
        id: category.id,
        name: category.name,
        type: category.type,
        description: category.description || '',
        active: category.active !== false,
      };
    },
    deleteCategory(id) {
      const category = this.categories.find(c => c.id === id);
      if (category?.is_system) {
        Alert.toastError("Registros do sistema não podem ser excluídos.");
        return;
      }
      Swal.fire({
        title: 'Tem certeza?',
        text: "Esta ação não pode ser desfeita!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, excluir!',
        cancelButtonText: 'Cancelar',
        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: 'btn btn-secondary'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          http.delete(`/places/${this.place.id_place}/finances/transaction-categories/${id}`).then(() => {
            this.loadCategories();
            Alert.toastSuccess("Categoria excluída com sucesso.");
          }).catch(e => {
            Alert.toastError(e.response?.data?.message || "Erro ao excluir categoria.");
          });
        }
      });
    },
  }
}
</script>

<style scoped>
</style>


